'use strict';

var callbackQueue = require('../lib/callbackQueue');
const performanceMeasure = require('../lib/performanceMeasure.js');
let measure = performanceMeasure('bootscripts:config');

// TempestIdentityPromise (required for the 'user' property) must be declared
// ahead of this script.
callbackQueue(
    'phxConfigQueue',
    window.TempestIdentityPromise.then(function () {
        measure.end();
        return {
            breakpoint: require('./breakpoint'),
            browser: require('./browser'),
            debugLog: require('./debugLog')(),
            device: require('./device'),
            user: require('./user'),
            features: require('./features'),
            membership: require('./membership'),
            identities: require('./trackingIdentities'),
        };
    })
);
